<div fxLayout="column" fxFlex="grow">
    <app-completed-consents [user]="user" [children]="children"></app-completed-consents>

    <div fxFlex="grow" fxLayout="row" style="margin-bottom: 60px;"></div>
</div>